<template>
  <div>
    <div class="d-flex justify-content-end">
      <div v-if="canEditCms" class="mr-2">
        <!-- <i class="fa fa-edit edit-icon" v-b-tooltip.hover title="Edit" v-b-modal="'workshopLogisticsFormModal'"></i> -->
        <a :href="fetchDetailEditUrlWithHashtag(`/workshops/${$route.params.id}`, '#web_behavior')">
          <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Edit" />
        </a>
      </div>
    </div>
    <!-- <b-modal
      id="workshopLogisticsFormModal"
      ref="workshopLogisticsFormModal"
      title= "Workshop Logistics"
      size="lg"
      centered
      hide-footer
      >
        <div>
          <b-form autocomplete="off">
            <div class="row">
              <div class="col-lg-12">
                <b-form-group label="Visas">
                  <ckeditor id="workshopLogisticsFormVisaText" v-model="workshopLogisticsForm.form_visa_text"></ckeditor>
                </b-form-group>
              </div>
              <div class="col-lg-12">
                <b-form-group label="Lodging in Berkeley">
                  <ckeditor id="workshopLogisticsFormLodgingText" v-model="workshopLogisticsForm.form_lodging_text"></ckeditor>
                </b-form-group>
              </div>
              <div class="col-lg-12">
                <button @click="submitWorkshopLogistics()" :disabled="loading" class="btn btn-primary btn-lg my-4">UPDATE</button>
                <span v-if="loading"><img src="/img/loader.gif" width="55" height="auto" /></span>
              </div>
            </div>
          </b-form>
        </div>
    </b-modal> -->
    <div v-if="isAuthenticated">
      <workshop-logistics-signed-tab />
    </div>
    <div v-else>
      <div>
        <div class="overlay">
          <signin :halt-redirect="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Signin from '@/pages/Signin.vue'
import WorkshopLogisticsSignedTab from './WorkshopLogisticsSignedTab.vue'
import mixin from '@/utils/mixin.js'

export default {
  name: 'WorkshopLogisticsSignedTabSection',
  components: { Signin, WorkshopLogisticsSignedTab },
  mixins: [mixin],
  props: ['data'],
  data () {
    return {
      // workshopLogisticsForm: {
      //   form_visa_text: this.data.workshop_logistics.visa_text,
      //   form_lodging_text: this.data.workshop_logistics.lodging_text
      // },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'canEditCms'])
  },
  methods: {
    submitWorkshopLogistics () {
      this.loading = true
      this.$http.post(process.env.VUE_APP_API_URL + `/workshops/update_workshop_logistics`, {
        id: this.$route.params.id,
        visa_text: this.workshopLogisticsForm.form_visa_text,
        lodging_text: this.workshopLogisticsForm.form_lodging_text
      })
      .then((res) => {
        if(res === undefined){
          //this.$toasted.global.error('Update has been failed.')
        }else if (res.data.error !== undefined) {
          this.$toasted.global.error(res.data.error)
        } else {
          this.$toasted.global.success('Updated Successfully')
          this.data.workshop_logistics.visa_text = this.workshopLogisticsForm.form_visa_text
          this.data.workshop_logistics.lodging_text = this.workshopLogisticsForm.form_lodging_text
          this.$refs['workshopLogisticsFormModal'].hide()
        }
        this.loading = false
      })
    }
  }
}
</script>
